import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 20px;
`




export const Grid = styled.div`
  padding:10px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap;
`

export const GridImg = styled.img`
  object-fit: contain;  
  margin-right:15px;
`

export const GridColor = styled.div`
  margin-right:7px;
  width:25px;
  height:25px;
  border-radius: 5px;
  border: solid 1px lightgray;
`


export const GridFont = styled.div`  
  width: 86px;
  height: 25px;
  padding:0 5px 0 5px;
  border-radius: 5px;
  background-color: rgba(32, 64, 120, 0.1);    
  display:flex;
  justify-content: flex-start;
  align-items: center;  
  margin-right: 5px;
`
export const GridFontContent = styled.div`
  padding: 5px;
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;  
  color: #000;
  display:inline-block;  
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const GridLabel = styled.div`
  object-fit: contain;
  padding: 5px;
  font-size: 10px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000;
`


